import {Component, computed, inject} from '@angular/core';
import {LinkComponent} from '../../../../../shared/components/link/link.component';
import {ResultTableService} from '../../../services/result-table.service';
import {ResultsTableComponent} from '../../results-table/results-table.component';
import {AppStore} from '../../../../../shared/store/app.store';
import {SelectComponent} from '../../../../../shared/components/select/select.component';
import {ResultsStore} from '../../../../../shared/store/results.store';

@Component({
  selector: 'app-filters-sidebar-header',
  imports: [
    LinkComponent,
    SelectComponent
  ],
  templateUrl: './filters-sidebar-header.html',
  styleUrl: './filters-sidebar-header.css',
})
export class FiltersSidebarHeader {
  resultTableService = inject(ResultTableService);
  appStore = inject(AppStore);
  resultsStore = inject(ResultsStore);

  readonly hasFilters = computed(() => Object.keys(this.resultTableService.filterConfig()).length);

  clearFilters() {
    this.resultTableService.clearFilters();
  }

  toggleSort(column: string) {
    // @ts-ignore
    this.resultTableService.toggleSort(column);
  }

  setPriceLevel(price_level_id: string) {
    const price_level = this.appStore.price_levels().find(({id}) => id == price_level_id);

    if (price_level) {
      this.resultsStore.setPriceLevel(price_level);
    }
  }

  priceLevels = computed(() => this.appStore.price_levels().map(({id, name}) => ({label: name, value: id})));
  sortOptions = computed(() => {
    const options = this.resultTableService.columns
      .filter(({sortable}) => sortable)
      .map(({data, header}) => ({label: header, value: data}))
      .sort(({label: a}, {label: b}) => a.localeCompare(b));
      options.unshift({label: 'Default', value: 'availability'});
      return options;
  });
}
